import { getDetailTaskSummaryAttribute as getDetailTaskSummaryAttributeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type TaskAttributeProps = {
    attribute?: string;
}

export const getDetailTaskSummaryAttribute = (): TaskAttributeProps => getDetailTaskSummaryAttributeDiagram();
